'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');



//////////////////
// WEBPACK FOOTER
// ./~/nmr-simulation/~/ml-matrix/src/index.js
// module id = 16
// module chunks = 0